import { compose } from 'redux';
import { connect } from 'react-redux';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import withReducer from '@Hooks/withReducer';
import InstitutionReducer from './InstitutionReducer';
import { institutionReducerKey } from './InstitutionConstants';
import Institution from './Institution';
import {
  cancel,
  login,
  goToLastSelected,
  init,
  selectGroup,
  selectInstitution,
  selectSearchedInstitution,
  changeRememberMe,
  resetState,
} from './InstitutionActions';
import {
  isLoading as isLoadingSelector,
  actualData as actualDataSelector,
  institutionsForSearch as institutionsForSearchSelector,
  institutionsGroups as institutionsGroupsSelector,
  isAnonymousUser as isAnonymousUserSelector,
  ipAddress as ipAddressSelector,
  notifications as notificationsSelector,
} from './InstitutionSelectors';

const mapStateToProps = (state, ownProps) => ({
  isAnonymousUser: isAnonymousUserSelector(state),
  ipAddress: ipAddressSelector(state),
  isLoading: isLoadingSelector(state),
  institutionsForSearch: institutionsForSearchSelector(state),
  institutionsGroups: institutionsGroupsSelector(state),
  actualData: actualDataSelector(state),
  notifications: notificationsSelector(state),
  ...ownProps,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  cancel: () => dispatch(cancel()),
  goToLastSelected: (href) => dispatch(goToLastSelected(href)),
  init: () => dispatch(init()),
  selectGroup: (group) => dispatch(selectGroup(group)),
  selectInstitution: (institution) => dispatch(selectInstitution(institution)),
  selectSearchedInstitution: (institution) => dispatch(selectSearchedInstitution(institution)),
  login: () => dispatch(login()),
  changeRememberMe: (value) => dispatch(changeRememberMe(value)),
  resetState: () => dispatch(resetState()),
  ...ownProps,
});

export default compose(
  withCombinedRouteParams,
  withReducer(institutionReducerKey, InstitutionReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(Institution);
